import { render, staticRenderFns } from "./CategoriasExtra.vue?vue&type=template&id=2d718dec&"
import script from "./CategoriasExtra.vue?vue&type=script&lang=js&"
export * from "./CategoriasExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports